(function() {
  function formatNewCards(sizes) {
    document.querySelectorAll('.m-product-card').forEach(function(card) {
      if (card.dataset.sizesProcessed) return;
      card.dataset.sizesProcessed = 'true';

      var sizeList = card.querySelector('.sizes-list');
      if (!sizeList) return;

      var brand = sizeList.dataset.brand;
      var gender = sizeList.dataset.gender;
      if (!brand || !gender || !sizes[brand] || !sizes[brand][gender]) return;

      card.querySelectorAll('.js-variant').forEach(function(span) {
        var us = span.dataset.size;
        if (sizes[brand][gender][us]) {
          span.textContent = sizes[brand][gender][us].eu;
        }
      });
    });
  }

  fetch('https:' + window.sizesUrlJSON)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var sizes = data.sizes;
      formatNewCards(sizes);

      new MutationObserver(function() {
        formatNewCards(sizes);
      }).observe(document.body, { childList: true, subtree: true });
    });
})();